<template>
    <div class="toolbox" id="overlay-switch-panel">
        <h4 class="container-title">
            Color
        </h4>
        <label @click="switchTo('c')">
            <input type="radio" v-model="overlayMode" value="c">
            By {{ allRegionModes.find(queryRegionMode).label }}
        </label>
        <label @click="switchTo('k')">
            <input type="radio" v-model="overlayMode" value="k">
            Smooth
        </label>
        <label style="position:absolute; bottom: 0;">
            <input type="checkbox" v-model="markersVisible" value="1" @change="markersToggle">
            Display {{ markersLabel }}
        </label>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OverlayPanel',

  computed: {
    ...mapGetters({
      allRegionModes: 'allRegionModes',
      markersSource: 'markersSource',
      overlayMode: 'overlayMode',
      queryRegionMode: 'queryRegionMode'
    }),

    markersLabel: function () {
      return this.markersSource === 'txCenters' ? 'transplant centers' : 'donor hospitals'
    },

    markersVisible: {
      get: function () { return this.$store.state.markersVisible },
      set: function (v) { this.$store.commit('setMarkersVisible', v) }
    }
  },

  methods: {
    markersToggle: function () {
      // this.$store.commit('setMarkersVisible', this.markersVisible)
    },

    switchTo: function (newMode) {
      this.$store.commit('setOverlayMode', newMode)
    }
  }
}
</script>

<style scoped>
#overlay-switch-panel {
    position: relative;
}

label {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Toolboxes/OverlayPanel.vue